// Initialisiert Firebase App + Auth aus den REACT_APP_FIREBASE_*-Umgebungsvariablen.
// Diese Variablen werden auf QA/Produktion beim Bauen über die GitHub-Actions-Workflows
// gesetzt (main.yaml/deployQA.yaml). Lokal im Devcontainer sind sie normalerweise nicht
// gesetzt - in dem Fall bleibt firebaseAuth hier bewusst null, und auth.js/menuApi.js
// nutzen dann einen lokalen Test-Token statt eines echten Logins (siehe getAdminToken
// in menuApi.js und den lokalen Fallback in AdminSpeiseplan.jsx).
import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

// Nur die vier Pflichtfelder für eine funktionsfähige Firebase-Verbindung prüfen.
// measurementId/messagingSenderId/storageBucket sind optional und fehlen z.B. wenn
// Analytics nicht eingerichtet ist, das soll aber den Login nicht blockieren.
const requiredConfigKeys = ["apiKey", "appId", "authDomain", "projectId"];

// Lokal (ohne REACT_APP_FIREBASE_*-Variablen) ist Firebase Auth einfach nicht konfiguriert.
// Der Admin-Editor fällt dann automatisch auf den Test-Token-Login zurück (siehe AdminSpeiseplan.jsx).
export const missingFirebaseConfigKeys = requiredConfigKeys.filter((key) => !firebaseConfig[key]);
export const isFirebaseConfigured = missingFirebaseConfigKeys.length === 0;

export const firebaseApp = isFirebaseConfigured
  ? getApps()[0] || initializeApp(firebaseConfig)
  : null;

export const firebaseAuth = firebaseApp ? getAuth(firebaseApp) : null;

export function requireFirebaseAuth() {
  if (!firebaseAuth) {
    throw new Error(
      "Firebase Auth ist noch nicht konfiguriert. Bitte prüfe die REACT_APP_FIREBASE_* Umgebungsvariablen."
    );
  }

  return firebaseAuth;
}
